import { render, staticRenderFns } from "./inflections-table-wide.vue?vue&type=template&id=a8099f4a&"
import script from "./inflections-table-wide.vue?vue&type=script&lang=js&"
export * from "./inflections-table-wide.vue?vue&type=script&lang=js&"
import style0 from "./inflections-table-wide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a8099f4a', component.options)
    } else {
      api.reload('a8099f4a', component.options)
    }
    module.hot.accept("./inflections-table-wide.vue?vue&type=template&id=a8099f4a&", function () {
      api.rerender('a8099f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections-table-wide.vue"
export default component.exports